var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered vjs-16-9 border",attrs:{"id":"videoPlayer","controls":"","playsinline":"","webkit-playsinline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }